import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Request {
  label: string;
  id: PilotId;
}

export const updateClientSectionName = async ({ label, id }: Request) => {
  const data = { label };

  const response = await pilot.put(`client-sections/${id}/`, data);

  return response;
};
